import { useState } from "react";

import ExpensesList from './ExpensesList'
import ExpenseFilter from "./ExpenseFilter";
import ExpenseChart from './ExpensesChart'
import Card from "../UI/Card";
import "../UI/Card.css";

function Expenses(props) {
  const [filteredYear, setFilteredYear] = useState("2020");

  const filterChangeHandler = (selectedYear) => {
    setFilteredYear(selectedYear);
  };


  const filteredExpenses = props.items.filter(year => year.date.getFullYear().toString() === filteredYear)
 console.log(filteredExpenses)

  return (
    <Card className="expenses">
      <ExpenseFilter
        selected={filteredYear}
        onChangeFilter={filterChangeHandler}
      />
      <ExpenseChart expenses={filteredExpenses} />
      <ExpensesList items={filteredExpenses}/>
    
    </Card>
  );
}

export default Expenses;

// import './expense-list.css'
// import ExpenseItem from './expense-item'

// function ExpenseList({ expenses }) {
//   const expenseList = expenses.map((expense) => (
//     <ExpenseItem
//       key={expense.id}
//       date={expense.date}
//       title={expense.title}
//       amount={expense.amount}
//     />
//   ))
//   return <div className="expense-list">{expenseList}</div>
// }

// export default ExpenseList
